import type { FC, ReactNode } from 'react';

import { Card, Divider, useBreakpoint } from '@hh.ru/magritte-ui';

import styles from 'components/BalanceAndBonuses/CardTemplate/CardTemplate.module.less';

const CardTemplate: FC<{
    mobileHeight: number;
    desktopHeight?: number;
    topContent: ReactNode;
    upClassName?: string;
    bottomContent?: ReactNode;
    loading?: boolean;
    hideDivider?: boolean;
}> = ({ loading, mobileHeight, desktopHeight = mobileHeight, topContent, bottomContent, hideDivider }) => {
    const { isMobile } = useBreakpoint();

    return (
        <Card.Skeleton
            loading={loading}
            height={isMobile ? mobileHeight : desktopHeight}
            stretched
            borderRadius={24}
            padding={0}
            style="primary"
            borderWidth="default"
            borderStyle="neutral"
        >
            <div className={styles.topWrapper}>{topContent}</div>

            {!hideDivider && <Divider />}

            {bottomContent && <div className={styles.bottomWrapper}>{bottomContent}</div>}
        </Card.Skeleton>
    );
};

export default CardTemplate;
